import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function FormulaPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="formula" />

    </>
  );
}

export default FormulaPhysTopics;